var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-nav"},[_c('router-link',{attrs:{"to":"/dashboard"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item d-flex justify-content-center align-items-center",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],staticStyle:{"margin":"0px","width":"60px"},attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":href},on:{"click":navigate}},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"/media/imatge-corporativa/logoxupxup.png"}})])])]}}])}),_c('router-link',{attrs:{"disabled":true,"to":"/teams"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/teams'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" Teams ")])])])]}}])}),_c('router-link',{attrs:{"to":"/paths"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/paths'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" Paths ")])])])]}}])}),_c('router-link',{attrs:{"to":"/projects"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/projects'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" Projects ")])])])]}}])}),_c('router-link',{attrs:{"to":"/ranking"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/ranking'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" Ranking ")])])])]}}])}),_c('router-link',{attrs:{"to":"/about"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/about'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" About ")])])])]}}])}),_c('router-link',{attrs:{"to":"/forums"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/forums'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" Forum ")])])])]}}])}),_c('router-link',{attrs:{"to":"/videoblog"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var href = ref.href;
      var navigate = ref.navigate;
      var isActive = ref.isActive;
      var isExactActive = ref.isExactActive;
return [_c('li',{staticClass:"menu-item",class:[
        isActive && 'menu-item-active',
        isExactActive && 'menu-item-active'
      ],attrs:{"aria-haspopup":"true","data-menu-toggle":"hover"}},[_c('a',{staticClass:"menu-link",attrs:{"href":'#/forums'},on:{"click":navigate}},[_c('span',{staticClass:"menu-text"},[_vm._v(" VideoBlog ")])])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }